export default {
  navigation: {
    INIT_MENU: "navigation/INIT_MENU",
    ERRORED: "navigation/ERRORED",
    GET_MENU: "navigation/GET_MENU",
    SET_TITLE: "navigation/SET_TITLE",
    REFRESH_TITLE: "navigation/REFRESH_TITLE",
  },
  notifications: {
    ENQUEUE_SNACKBAR: "notifications/ENQUEUE_SNACKBAR",
    CLOSE_SNACKBAR: "notifications/CLOSE_SNACKBAR",
    REMOVE_SNACKBAR: "notifications/REMOVE_SNACKBAR",
  },
  accountVerification: {
    FETCH_STATUS: "accountVerification/FETCH_STATUS",
    FETCH_STATUS_OK: "accountVerification/FETCH_STATUS_OK",
    FETCH_STATUS_ERROR: "accountVerification/FETCH_STATUS_ERROR",
    EMAIL_VERIFIED: "accountVerification/EMAIL_VERIFIED",
    SEND_VERIFICATION_EMAIL: "accountVerification/SEND_VERIFICATION_EMAIL",
    SEND_VERIFICATION_EMAIL_ERROR: "accountVerification/SEND_VERIFICATION_EMAIL_ERROR",
    SET_VERIFICATION_EMAIL_SENT: "accountVerification/SET_VERIFICATION_EMAIL_SENT",
    CLEAR_VERIFICATION_EMAIL_SENT: "accountVerification/CLEAR_VERIFICATION_EMAIL_SENT",
  },
  geo: {
    FETCH_COUNTRIES: "geo/FETCH_COUNTRIES",
    FETCH_COUNTRIES_OK: "geo/FETCH_COUNTRIES_OK",
    FETCH_COUNTRIES_ERROR: "geo/FETCH_COUNTRIES_ERROR",
  },
  plan: {
    FETCH_AVAILABLE: "plans/FETCH_AVAILABLE",
    FETCH_AVAILABLE_OK: "plans/FETCH_AVAILABLE_OK",
    FETCH_AVAILABLE_ERROR: "plans/FETCH_AVAILABLE_ERROR",
  },
  subscription: {
    FETCH_INFO: "subscription/FETCH_INFO",
    FETCH_INFO_OK: "subscription/FETCH_INFO_OK",
    FETCH_INFO_ERROR: "subscription/FETCH_INFO_ERROR",
  },
  billingInformation: {
    FETCH: "billingInformation/FETCH",
    FETCH_OK: "billingInformation/FETCH_OK",
    FETCH_ERROR: "billingInformation/FETCH_ERROR",
  },
  settings: {
    CHANGE_LANGUAGE: "settings/CHANGE_LANGUAGE",
  },
  paymentMethods: {
    FETCH: "paymentMethods/FETCH",
    FETCH_OK: "paymentMethods/FETCH_OK",
    FETCH_ERROR: "paymentMethods/FETCH_ERROR",
    REMOVE: "paymentMethods/REMOVE",
    REMOVE_OK: "paymentMethods/REMOVE_OK",
    SET_AS_PRIMARY: "paymentMethods/SET_AS_PRIMARY",
    SET_AS_PRIMARY_OK: "paymentMethods/SET_AS_PRIMARY_OK",
    SET_PROCESSING: "paymentMethods/SET_PROCESSING",
  },
  invoices: {
    FETCH: "invoices/FETCH",
    FETCH_OK: "invoices/FETCH_OK",
    FETCH_ERROR: "invoices/FETCH_ERROR",
    FETCH_MORE: "invoices/RESET"
  }
};
